import { useState } from 'react'
import { Select, Col } from 'antd'
import { ALLOWED_ATTACHMENT_SOURCE_TYPE } from '@OpsQuality/constants'
import { PhotosLayoutType } from '@OpsQuality/JobRequestDetails/components/types'
import styles from '@OpsQuality/styles.css'

import Box from '~/core/Box'
import FileList from '~/components/FileUploadList'

export default function PhotosTabLayout(props: PhotosLayoutType) {
    const [toggleObj, setToggledObj] = useState({
        filterType: 'ALL',
        attachhmentUrl: '',
        partName: '',
        rotation: 0,
    })

    const filteredPhotos = () => {
        const { photos } = props

        const mpPhotos = photos.filter(
            photoAttachment =>
                photoAttachment.source === ALLOWED_ATTACHMENT_SOURCE_TYPE.MP,
        )

        const qcPhotos = photos.filter(
            photoAttachment =>
                photoAttachment.source === ALLOWED_ATTACHMENT_SOURCE_TYPE.QC,
        )

        switch (toggleObj.filterType) {
            case 'ALL':
                return [...mpPhotos, ...qcPhotos]
            case 'MP':
                return mpPhotos
            case 'FICTIV_QC':
                return qcPhotos
            default:
                return []
        }
    }
    const files = filteredPhotos()

    return (
        <Box direction="col">
            <Col xs={24} sm={6}>
                <Select
                    defaultValue="ALL"
                    onChange={(value: any) =>
                        setToggledObj(prevstate => ({
                            ...prevstate,
                            filterType: value,
                        }))
                    }
                    className={styles.photoSelect}
                >
                    <Select.Option value="ALL">All</Select.Option>
                    <Select.Option value="MP">MP</Select.Option>
                    <Select.Option value="FICTIV_QC">Fictiv QC</Select.Option>
                </Select>
            </Col>
            <Box
                flexWrap="wrap"
                justifyContent="between"
                className={styles.flexAlign}
            >
                <FileList
                    files={files}
                    modalControls={{
                        backFwd: true,
                        rotate: true,
                        zoom: true,
                        newWindow: true,
                        canBeDeleted: false,
                    }}
                    modalCss={styles.docViewerModal}
                    modalTitle
                    showNames
                    typeOfModule="inventoryQc"
                    showIcons={false}
                    large
                />
            </Box>
        </Box>
    )
}
